const industriesData = [
  "3D Printing",
  "Aerospace and Defense",
  "Agricultural Biotechnology",
  "Agriculture",
  "Artificial Intelligence",
  "Art and Design",
  "Automotive",
  "Aviation",
  "Banking",
  "Biotechnology",
  "Blockchain",
  "Broadcasting and Media",
  "Carbon Capture and Storage",
  "Cell Therapy",
  "Construction and Architecture",
  "Consumer Goods",
  "Consulting and Business Services",
  "Cryptocurrency",
  "Culinary Arts",
  "Cybersecurity",
  "Data Analytics and Business Intelligence",
  "Defense",
  "E-commerce",
  "Education",
  "Education Technology",
  "E-sports and Gaming Analytics",
  "Energy and Utilities",
  "Engineering",
  "Entertainment",
  "Environmental and Green Technology",
  "Event Planning and Management",
  "Fashion and Beauty",
  "Film and Television",
  "Financial Services",
  "Financial Technology",
  "Fitness and Wellness",
  "Food and Beverage",
  "Gaming",
  "Genomics",
  "Government and Public Administration",
  "Healthcare and Medical",
  "Health and Wellness",
  "Hospitality and Tourism",
  "Human Resources",
  "Information Technology",
  "Insurance and Risk Management",
  "Internet of Things (IoT)",
  "Law and Legal Services",
  "Logistics",
  "Luxury Goods and Services",
  "Manufacturing and Industrial",
  "Maritime",
  "Market Research and Analysis",
  "Marketing",
  "Media and Communications",
  "Music and Entertainment",
  "Non-Profit and Community Development",
  "Personal Care and Beauty Services",
  "Pet Care and Animal Services",
  "Pharmaceutical",
  "Petroleum and Natural Gas",
  "Quantum Computing",
  "Real Estate and Property",
  "Renewable Energy and Sustainability",
  "Research and Development",
  "Retail and Consumer Goods",
  "Robotic Process Automation (RPA)",
  "Robotics",
  "Security and Law Enforcement",
  "Senior Care and Assisted Living",
  "Social Services",
  "Space Exploration",
  "Space Tourism",
  "Sports and Recreation",
  "Supply Chain Management",
  "Telecommunications",
  "Technology",
  "Trade and Import/Export",
  "Transportation and Logistics",
  "Travel and Leisure",
  "Vertical Farming",
  "Virtual Reality and Augmented Reality"
];


const skillsData = [
  "3D Modeling",
  "3D Printing",
  "Accounting",
  "Actuarial Science",
  "Agile Coaching",
  "Agile Project Management",
  "Animation",
  "Architectural Design",
  "Artificial Intelligence Development",
  "Audio Engineering",
  "AWS/Azure/GCP Architecture",
  "Augmented Reality Development",
  "Automated Testing",
  "Baking",
  "Band Management",
  "Big Data Analytics",
  "Blockchain Development",
  "Brand Strategy",
  "Business Continuity Planning",
  "CAD Design",
  "Calendar & Email Management",
  "Certificate & Diploma Training",
  "Chartered Financial Analysis",
  "Chemical Engineering",
  "Childcare Consulting",
  "Clinical Trial Management",
  "Cloud Architecture",
  "Cloud Computing",
  "CMS Development",
  "CNC Programming",
  "Crisis Management",
  "Contract Negotiation",
  "Content Strategy",
  "Content Writing",
  "Contract Law",
  "Copywriting",
  "Corporate Training",
  "Corporate Law",
  "Costume Design",
  "Creative Writing",
  "CRM Administration",
  "Cryptocurrency Analysis",
  "Customer Relationship Management",
  "Customer Service Excellence",
  "Cybersecurity",
  "Data Analytics",
  "Data Engineering",
  "Data Entry",
  "Data Mining",
  "Data Recovery",
  "Data Visualization",
  "Database Management",
  "Debt & Credit Counseling",
  "Dental Consulting",
  "Design Thinking",
  "DevOps Practices",
  "Digital Marketing",
  "Direct Sales",
  "Disaster Relief Planning",
  "Documentary Filmmaking",
  "E-commerce Optimization",
  "E-commerce Strategy",
  "Education Technology",
  "E-learning Development",
  "Electrical Engineering",
  "Embedded Systems",
  "Email Marketing",
  "Emergency Preparedness",
  "Employee Onboarding",
  "Engineering Design",
  "Enterprise Architecture",
  "Environmental Consulting",
  "Event Planning and Management",
  "Excel & Spreadsheets",
  "Figma/Sketch/XD",
  "Film Editing",
  "Film Production",
  "Financial Forecasting",
  "Financial Modeling",
  "Financial Regulation Advisory",
  "Financial Technology",
  "Finance Compliance",
  "Fitness Training Program Design",
  "Food Safety Consulting",
  "Forecasting & Budgeting",
  "Foreign Language Instruction",
  "Forensic Analysis",
  "Full-Stack Web Development",
  "Game Design",
  "Game Development",
  "Grant Writing",
  "Graphic Design",
  "Healthcare Coaching",
  "Healthcare Technology",
  "Historic Research",
  "Homeopathic Medicine",
  "Hospitality Management",
  "HR Consulting",
  "Human Resources Management",
  "ICT Project Management",
  "Illustration",
  "Import/Export Consulting",
  "Industrial Automation",
  "Information Architecture",
  "Information Technology Support",
  "Infrastructure Engineering",
  "Instructional Design",
  "Intellectual Property Law",
  "International Law",
  "Internet of Things (IoT)",
  "Investment Strategy",
  "IT Support & Helpdesk",
  "Java / .NET / Python / Go / Ruby Development",
  "Jewelry Design",
  "Journalism & Reporting",
  "Journalism Editing",
  "Journalism Video Production",
  "Journalism Podcasting",
  "Journalism Live Reporting",
  "Knowledge Management",
  "Labor Relations",
  "Language Localization",
  "Lean Manufacturing",
  "Legal Consulting",
  "Legal Research",
  "Legal Writing",
  "Leadership & Team Management",
  "LMS Administration",
  "Logistics Coordination",
  "Machine Learning Projects",
  "Magic & Illusion",
  "Maritime Navigation",
  "Market Analysis",
  "Market Research",
  "Marketing Automation",
  "Matchmaking Services",
  "Media Buying",
  "Media Planning",
  "Mechanical Engineering",
  "Medical Imaging",
  "Metalwork & Welding",
  "Metrology",
  "Meteorology",
  "Mobile App Development",
  "Money & Budget Coaching",
  "Motivational Speaking",
  "Music Production",
  "Natural Language Processing",
  "Negotiation",
  "Network Administration",
  "Network Marketing",
  "Networking Fundamentals",
  "NoSQL Databases",
  "Nursing Education",
  "Occupational Therapy",
  "Oil & Gas Engineering",
  "Online Course Creation",
  "Open-Source Contribution",
  "Operations Management",
  "PPC Campaign Management",
  "Patent Law",
  "Personal Finance Planning",
  "Personal Training",
  "Petroleum Engineering",
  "Pharmaceutical Consulting",
  "Photography",
  "Physical Therapy",
  "Presentation & Public Speaking",
  "Predictive Modeling",
  "Printmaking",
  "Process Improvement",
  "Product Management",
  "Product Strategy",
  "Project Management",
  "Property Management",
  "Psychological Counseling",
  "Public Health Advisory",
  "Public Policy Consulting",
  "Public Relations Strategy",
  "Python / R / MATLAB Data Analysis",
  "Quality Assurance Testing",
  "Quantum Computing Research",
  "Real Estate Analysis",
  "Recruitment & Talent Acquisition",
  "Regulatory Compliance",
  "Renewable Energy Consulting",
  "Research and Development",
  "Retail Merchandising",
  "Robotics Engineering",
  "Sales Funnel Optimization",
  "Sales Strategy",
  "SAP / Oracle ERP Administration",
  "SaaS Product Management",
  "Scrum Mastery",
  "Search Engine Optimization (SEO)",
  "Security and Law Enforcement",
  "Self-Publishing",
  "Senior Care Planning",
  "Shipping & Customs Brokerage",
  "Simulation & Modeling",
  "Six Sigma",
  "Smart Home Design",
  "Social Media Management",
  "Social Media Marketing",
  "Software Development",
  "Sound Design",
  "Space Exploration Projects",
  "Space Tourism Planning",
  "Speech Therapy",
  "Sports Coaching",
  "SQL Databases",
  "Statistical Analysis",
  "Supply Chain Management",
  "Sustainability Consulting",
  "Talent & Performance Management",
  "Tax Advisory",
  "Technical Documentation",
  "Technical Writing",
  "Telecommunications Engineering",
  "Test Automation",
  "Theater Production",
  "Time Management",
  "Tokenomics Design",
  "Translation Services",
  "Travel Writing",
  "Troubleshooting & Debugging",
  "UI / UX Design",
  "User Research",
  "User Interface Design",
  "UX Research",
  "Video Editing",
  "Voice Over",
  "VR / AR Development",
  "Warehouse Management",
  "Waste Management & Recycling",
  "Wearable Technology Development",
  "Web Application Development",
  "Web Development",
  "Wedding Planning",
  "Wholesale Distribution",
  "Wildlife Conservation",
  "XML / JSON API Design",
  "Yield & Field Analytics",
  "YouTube Content Creation",
  "Zoological Research"
];


const countries = [
  { label: "Afghanistan" },
  { label: "Albania" },
  { label: "Algeria" },
  { label: "Andorra" },
  { label: "Angola" },
  { label: "Antigua and Barbuda" },
  { label: "Argentina" },
  { label: "Armenia" },
  { label: "Australia" },
  { label: "Austria" },
  { label: "Azerbaijan" },
  { label: "Bahamas" },
  { label: "Bahrain" },
  { label: "Bangladesh" },
  { label: "Barbados" },
  { label: "Belarus" },
  { label: "Belgium" },
  { label: "Belize" },
  { label: "Benin" },
  { label: "Bhutan" },
  { label: "Bolivia" },
  { label: "Bosnia and Herzegovina" },
  { label: "Botswana" },
  { label: "Brazil" },
  { label: "Brunei" },
  { label: "Bulgaria" },
  { label: "Burkina Faso" },
  { label: "Burundi" },
  { label: "Cabo Verde" },
  { label: "Cambodia" },
  { label: "Cameroon" },
  { label: "Canada" },
  { label: "Central African Republic" },
  { label: "Chad" },
  { label: "Chile" },
  { label: "China" },
  { label: "Colombia" },
  { label: "Comoros" },
  { label: "Congo" },
  { label: "Costa Rica" },
  { label: "Croatia" },
  { label: "Cuba" },
  { label: "Cyprus" },
  { label: "Czech Republic" },
  { label: "Denmark" },
  { label: "Djibouti" },
  { label: "Dominica" },
  { label: "Dominican Republic" },
  { label: "Ecuador" },
  { label: "Egypt" },
  { label: "El Salvador" },
  { label: "Equatorial Guinea" },
  { label: "Eritrea" },
  { label: "Estonia" },
  { label: "Eswatini" },
  { label: "Ethiopia" },
  { label: "Fiji" },
  { label: "Finland" },
  { label: "France" },
  { label: "Gabon" },
  { label: "Gambia" },
  { label: "Georgia" },
  { label: "Germany" },
  { label: "Ghana" },
  { label: "Greece" },
  { label: "Grenada" },
  { label: "Guatemala" },
  { label: "Guinea" },
  { label: "Guinea-Bissau" },
  { label: "Guyana" },
  { label: "Haiti" },
  { label: "Honduras" },
  { label: "Hungary" },
  { label: "Iceland" },
  { label: "India" },
  { label: "Indonesia" },
  { label: "Iran" },
  { label: "Iraq" },
  { label: "Ireland" },
  { label: "Israel" },
  { label: "Italy" },
  { label: "Jamaica" },
  { label: "Japan" },
  { label: "Jordan" },
  { label: "Kazakhstan" },
  { label: "Kenya" },
  { label: "Kiribati" },
  { label: "Kosovo" },
  { label: "Kuwait" },
  { label: "Kyrgyzstan" },
  { label: "Laos" },
  { label: "Latvia" },
  { label: "Lebanon" },
  { label: "Lesotho" },
  { label: "Liberia" },
  { label: "Libya" },
  { label: "Liechtenstein" },
  { label: "Lithuania" },
  { label: "Luxembourg" },
  { label: "Madagascar" },
  { label: "Malawi" },
  { label: "Malaysia" },
  { label: "Maldives" },
  { label: "Mali" },
  { label: "Malta" },
  { label: "Marshall Islands" },
  { label: "Mauritania" },
  { label: "Mauritius" },
  { label: "Mexico" },
  { label: "Micronesia" },
  { label: "Moldova" },
  { label: "Monaco" },
  { label: "Mongolia" },
  { label: "Montenegro" },
  { label: "Morocco" },
  { label: "Mozambique" },
  { label: "Myanmar" },
  { label: "Namibia" },
  { label: "Nauru" },
  { label: "Nepal" },
  { label: "Netherlands" },
  { label: "New Zealand" },
  { label: "Nicaragua" },
  { label: "Niger" },
  { label: "Nigeria" },
  { label: "North Korea" },
  { label: "North Macedonia" },
  { label: "Norway" },
  { label: "Oman" },
  { label: "Pakistan" },
  { label: "Palau" },
  { label: "Palestine" },
  { label: "Panama" },
  { label: "Papua New Guinea" },
  { label: "Paraguay" },
  { label: "Peru" },
  { label: "Philippines" },
  { label: "Poland" },
  { label: "Portugal" },
  { label: "Qatar" },
  { label: "Romania" },
  { label: "Russia" },
  { label: "Rwanda" },
  { label: "Saint Kitts and Nevis" },
  { label: "Saint Lucia" },
  { label: "Saint Vincent and the Grenadines" },
  { label: "Samoa" },
  { label: "San Marino" },
  { label: "Sao Tome and Principe" },
  { label: "Saudi Arabia" },
  { label: "Senegal" },
  { label: "Serbia" },
  { label: "Seychelles" },
  { label: "Sierra Leone" },
  { label: "Singapore" },
  { label: "Slovakia" },
  { label: "Slovenia" },
  { label: "Solomon Islands" },
  { label: "Somalia" },
  { label: "South Africa" },
  { label: "South Korea" },
  { label: "South Sudan" },
  { label: "Spain" },
  { label: "Sri Lanka" },
  { label: "Sudan" },
  { label: "Suriname" },
  { label: "Sweden" },
  { label: "Switzerland" },
  { label: "Syria" },
  { label: "Taiwan" },
  { label: "Tajikistan" },
  { label: "Tanzania" },
  { label: "Thailand" },
  { label: "Timor-Leste" },
  { label: "Togo" },
  { label: "Tonga" },
  { label: "Trinidad and Tobago" },
  { label: "Tunisia" },
  { label: "Turkey" },
  { label: "Turkmenistan" },
  { label: "Tuvalu" },
  { label: "Uganda" },
  { label: "Ukraine" },
  { label: "United Arab Emirates" },
  { label: "United Kingdom" },
  { label: "United States" },
  { label: "Uruguay" },
  { label: "Uzbekistan" },
  { label: "Vanuatu" },
  { label: "Vatican City" },
  { label: "Venezuela" },
  { label: "Vietnam" },
  { label: "Yemen" },
  { label: "Zambia" },
  { label: "Zimbabwe" },
];

const industries = industriesData.map((label) => ({
  label,
  value: label,
}));

const skills = skillsData.map((label) => ({
  label,
  value: label,
}));

const countriesData = countries.map((l) => l.label);

const tags = [
  { label: "Founding Team" },
  { label: "Contributor" },
  { label: "Intern/Volunteer" },
  { label: "Consultant" },
  { label: "Investor" },
];

const stages = [
  { label: "Idea" },
  { label: "Prototype" },
  { label: "Start-up" },
  { label: "Project" },
  { label: "Growth" },
  { label: "Maturity" },
];

const sorting = [
  { label: "Recently Modified" },
  { label: "Newest First" },
  { label: "A-Z" },
  { label: "Z-A" },
  { label: "Followers (P1)" },
];

const emojis = [
  "❤️ - Red Heart",
  "🎉 - Party Popper",
  "👍 - Thumbs Up",
  "👏 - Clapping Hands",
  "🌟 - Glowing Star",
  "🌈 - Rainbow",
  "✨ - Sparkles",
  "🍕 - Pizza",
  "🍷 - Wine Glass",
  "🎈 - Balloon",
  "🎶 - Musical Notes",
  "🎵 - Musical Note",
  "🎊 - Confetti Ball",
  "🎁 - Wrapped Gift",
  "📷 - Camera",
  "📱 - Mobile Phone",
  "📚 - Books",
  "📺 - Television",
  "💻 - Laptop Computer",
  "💡 - Light Bulb",
  "💯 - Hundred Points",
  "🔥 - Fire",
  "🚀 - Rocket",
  "🌸 - Cherry Blossom",
  "🌼 - Blossom",
  "🍀 - Four Leaf Clover",
  "🍂 - Fallen Leaf",
  "🌞 - Sun with Face",
  "🌝 - Full Moon with Face",
  "🌎 - Globe Showing Americas",
  "🌍 - Globe Showing Europe-Africa",
  "⭐️ - Star",
  "🌊 - Water Wave",
  "🍔 - Hamburger",
  "🍟 - French Fries",
  "🍦 - Soft Ice Cream",
  "🍩 - Doughnut",
  "🍻 - Clinking Beer Mugs",
  "🍹 - Tropical Drink",
  "🎮 - Video Game",
  "🎬 - Clapper Board",
  "🎤 - Microphone",
  "🎸 - Guitar",
  "🎭 - Performing Arts",
  "🎩 - Top Hat",
  "🎰 - Slot Machine",
  "🎳 - Bowling",
  "🎲 - Game Die",
  "🎻 - Violin",
  "🎼 - Musical Score",
  "🏆 - Trophy",
  "⚽️ - Soccer Ball",
  "🏀 - Basketball",
  "🏈 - American Football",
  "🎾 - Tennis",
  "🏓 - Ping Pong",
  "🏸 - Badminton",
  "🏒 - Ice Hockey",
  "🚗 - Car",
  "🚲 - Bicycle",
  "🚌 - Bus",
  "🚀 - Rocket",
  "🚢 - Ship",
  "✈️ - Airplane",
  "🚁 - Helicopter",
  "🚂 - Locomotive",
  "🚒 - Fire Engine",
  "🚓 - Police Car",
  "🚑 - Ambulance",
  "🚔 - Oncoming Police Car",
  "🚕 - Taxi",
  "🚚 - Delivery Truck",
  "🚜 - Tractor",
  "🛵 - Motor Scooter",
  "🚤 - Speedboat",
  "⛵️ - Sailboat",
  "🚲 - Bicycle",
  "🛴 - Kick Scooter",
  "🚅 - Bullet Train",
  "🎯 - Direct Hit",
  "🎱 - Pool 8 Ball",
  "🏹 - Bow and Arrow",
  "🏓 - Ping Pong",
  "🏸 - Badminton",
  "🥅 - Goal Net",
  "🥇 - 1st Place Medal",
  "🥈 - 2nd Place Medal",
  "🥉 - 3rd Place Medal",
  "🎖️ - Military Medal",
  "🏅 - Sports Medal",
  "🎮 - Video Game",
  "🎲 - Game Die",
  "🧩 - Puzzle Piece",
  "♟️ - Chess Pawn",
  "🎯 - Direct Hit",
  "🎱 - Pool 8 Ball",
  "🏂 - Snowboarder",
  "🚣‍♀️ - Woman Rowing Boat",
  "🚣‍♂️ - Man Rowing Boat",
  "🛌 - Person in Bed",
  "🛋️ - Couch and Lamp",
  "🚽 - Toilet",
  "🚿 - Shower",
  "🛁 - Bathtub",
  "⌚ - Watch",
  "📱 - Mobile Phone",
  "💻 - Laptop Computer",
  "🖥️ - Desktop Computer",
  "🖨️ - Printer",
  "🖱️ - Computer Mouse",
  "🖲️ - Trackball",
  "🕹️ - Joystick",
  "🗜️ - Clamp",
  "⌨️ - Keyboard",
  "💽 - Computer Disk",
  "💾 - Floppy Disk",
  "💿 - Optical Disk",
  "📀 - DVD",
  "🎥 - Movie Camera",
  "🎞️ - Film Frames",
  "📽️ - Film Projector",
  "📷 - Camera",
  "📸 - Camera with Flash",
  "📹 - Video Camera",
  "📼 - Videocassette",
  "📺 - Television",
  "📻 - Radio",
  "🎙️ - Studio Microphone",
  "🎚️ - Level Slider",
  "🎛️ - Control Knobs",
  "⏱️ - Stopwatch",
  "⏲️ - Timer Clock",
  "⏰ - Alarm Clock",
  "🕰️ - Mantelpiece Clock",
  "⌛ - Hourglass Done",
  "⏳ - Hourglass Not Done",
  "📡 - Satellite Antenna",
  "🔋 - Battery",
  "🔌 - Electric Plug",
  "💡 - Light Bulb",
  "🔦 - Flashlight",
  "🕯️ - Candle",
  "🧯 - Fire Extinguisher",
  "🛢️ - Oil Drum",
  "💸 - Money with Wings",
  "💵 - Dollar Banknote",
  "💴 - Yen Banknote",
  "💶 - Euro Banknote",
  "💷 - Pound Banknote",
  "💰 - Money Bag",
  "💳 - Credit Card",
  "🧾 - Receipt",
  "💎 - Gem Stone",
  "📦 - Package",
  "📫 - Closed Mailbox with Raised Flag",
  "📪 - Closed Mailbox with Lowered Flag",
  "📬 - Open Mailbox with Raised Flag",
  "📭 - Open Mailbox with Lowered Flag",
  "📮 - Postbox",
  "🗳️ - Ballot Box with Ballot",
  "✉️ - Envelope",
  "📩 - Envelope with Arrow",
  "📨 - Incoming Envelope",
  "📧 - E-Mail",
  "💌 - Love Letter",
  "📤 - Outbox Tray",
  "📥 - Inbox Tray",
  "📦 - Package",
  "📯 - Postal Horn",
  "📜 - Scroll",
];

export {
  emojis,
  industriesData,
  skillsData,
  industries,
  skills,
  countries,
  tags,
  stages,
  sorting,
  countriesData,
};
